import React from 'react'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

export default function P222Search({ data,setDialog }) {

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
                <label>เลขที่สัญญา</label>
                <InputText
                    type="text"  placeholder="เลขที่สัญญา"
                    disabled
                    maxLength="20"
                    value={data.contractNo}

                />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <label>บริษัท</label>
                <InputText
                    type="text"  placeholder="บริษัท"
                    disabled
                    maxLength="200"
                    value={data.contractorName}

                />
            </div>
            <div className="p-field p-col-12 p-md-2">
                <Button
                    className="p-button p-button-secondary btn-srh-responsive"
                    icon="pi pi-arrow-left"
                    label="กลับหน้าจอหลัก"
                    style={{ display: 'flex' }}
                    onClick={() => setDialog({dialog:false}) }
                />
            </div>


        </div>
    )
}
